// @flow
import { get } from "lodash";
import type { OperationComponent } from "@apollo/client";
import { type Dispatch } from "redux";
import tvgConf from "@tvg/conf";
import type { RaceProgram } from "@tvg/types/Race";
import createRaceDataForHeader from "@fdr/utils/RaceHeaderUtils";
import { setTrackRaces } from "@fdr/shared-actions/ProgramPageActions";
import type { Props } from "../types";

const QUERY_VARIABLES = {
  trackAbbr: null,
  wagerProfile: "FDR-Generic"
};

const getRacesData = (races: RaceProgram[], dispatch: Dispatch<*>) => {
  const racesData = [];
  if (races) {
    races.forEach((race) => {
      const raceData = createRaceDataForHeader(race);
      racesData.push(raceData);
    });
    dispatch(setTrackRaces(races));
    return racesData;
  }
  return [];
};

const getCurrentRace = (races, raceNumber) => {
  const result =
    races &&
    races.length > 0 &&
    races.find((race) => race.raceNumber === raceNumber);

  return result || null;
};

export default {
  options: (props: Props) => {
    const variables = {
      ...QUERY_VARIABLES,
      trackAbbr: get(props, "trackAbbr", "").toUpperCase(),
      wagerProfile: get(props, "wagerProfile", ""),
      ...tvgConf().graphContext()
    };

    const poll = get(props, "hasWebSockets", false) ? {} : { pollInterval: 0 };

    return {
      ...poll,
      fetchPolicy: "cache-and-network",
      nextFetchPolicy: "cache-first",
      ssr: false,
      variables
    };
  },
  props: (result: OperationComponent<Response>) => {
    const races = result.data.loading
      ? get(result, "data.previousData.track.races", [])
      : get(result, "data.track.races");

    const stayLoading = (races || []).length
      ? get("ownProps.trackAbbr", result) !== get("[0].track.trackCode", races)
      : false;

    return {
      race: getCurrentRace(
        races,
        get(
          result,
          stayLoading ? "ownProps.previousRaceNumber" : "ownProps.raceNumber"
        )
      ),
      races,
      racesData: getRacesData(races, result.ownProps.dispatch),
      isLoading: result.data.loading || stayLoading,
      subscribeToMore:
        get(result, "ownProps.hasWebSockets", false) && !result.data.loading
          ? result.data.subscribeToMore
          : null
    };
  }
};
